<template>
  <div class="xcard">
    <v-btn v-if="atras" small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h3 class="text-center mb-0">Asignar datos al modulo</h3>
    <div>
      <p class="mb-0"><b>Modulo:</b> {{ parametros.nombre }}</p>
      <p class="mb-0"><b>Numero modulo:</b> {{ parametros.numero }}</p>
      <p class="mb-0"><b>ID Modulo:</b> {{ parametros.modulo_id }}</p>
      <p class="mb-0"><b>ID Programa modulo:</b> {{ parametros.programa_modulo_id }}</p>
    </div>
    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-col cols="12" sm="4" lg="2">
            * Docente:
          </v-col>
          <v-col cols="12" sm="8" lg="10">
            <!-- <v-text-field label="Docente" placeholder="docente" outlined dense></v-text-field> -->
            <v-combobox v-model="filtroestudiante" :items="estudiantes" label="Carnet de la persona" :loading="isloadingestudent" class="mb-3" loader-height="6" placeholder="tecla enter para buscar..." hide-details outlined dense ></v-combobox>
          </v-col>

          <v-col cols="12" sm="4" lg="2">
            * Carga horaria:
          </v-col>
          <v-col cols="12" sm="8" lg="10">
            <v-text-field v-model.number="carga_horaria" label="Carga horaria:" placeholder="Carga horaria..." type="number" outlined dense ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" lg="2">
            * Certificado:
          </v-col>
          <v-col cols="12" sm="8" lg="10">
            <v-file-input label="Fondo del certificado:" accept="image/png, image/jpeg, image/jpg" prepend-icon="" @change="onFileChangeb" outlined dense ></v-file-input>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <v-img :src="base64cert"></v-img>
            <!-- <iframe :src="base64cert" width="100%" height="550"></iframe> -->
            <small v-if="base64cert" class="red--text">Previsualizacion del certificado.</small>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- <ckeditor v-model="xbody" :config="editorConfig"></ckeditor> -->

    <v-progress-linear indeterminate color="purple" height="2" v-if="loading" />

    <p class="text-center red--text">{{ msg }}</p>

    <div class="d-flex justify-center">
      <v-btn tile class="green darken-2" :disabled="loading" dark @click="saveData()">
        <v-icon small left> mdi-check </v-icon> Guardar Datos
      </v-btn>
    </div>

    <div v-show="false"><ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" /></div>
  </div>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import xaxios from '@/xaxios';
  export default {
    props:{
      atras: {type:Boolean, default: true}
    },
    data() {
      return {
        msg: '',
        xbody: '',
        editorConfig: {
          removePlugins: 'image',
          extraPlugins: 'easyimage',
          height: 500,
        },
        timeoutHnd: 0,
        filtroestudiante: null,
        isloadingestudent: false,
        loading: false,
        estudiantes: [],
        parametros: {
          nombre: '',
          modulo_id: null,
          numero: null,
          programa_modulo_id: null,
        },
        base64cert: null,
        carga_horaria: 0,
        archivo_id: null,
      };
    },
    components: { ABuscarPersona },
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      onFileChangeb(file) {
        let vue = this;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          vue.base64cert = reader.result;
          vue.archivo_id = null;
          window.console.log(vue.base64cert);
        };
        reader.onerror = function(err) {
          window.console.log('Error:', err);
        };
      },
      resultadobusquedaest() {},
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      getDatos() {
        window.console.log(this.filtroestudiante);
      },
      getFileById() {
        // 78ef2b55-7b9b-4d24-ba7a-887b32cd3a36
        // http://66.42.76.192:5008/v1/files/f97275cf-f91a-4b32-a215-9b4d65357021
        let fileid = 'f97275cf-f91a-4b32-a215-9b4d65357021';
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_SERVERFILES}${fileid}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      getSaveData(programa_modulo_id) {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/programamodulocertificado/${programa_modulo_id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('getSaveData::',data);
            // data:image/png;base64,

            if (data) {
              vue.carga_horaria = data.carga_horaria;
              vue.archivo_id = data.archivo_id;
              if (data.archivo) {
                vue.base64cert = `data:${data.archivo.mimetype};base64,${data.archivo.file64}`;
                vue.getUserdata(data.docente_id);
              } else {
                vue.loading = false;
              }
            }
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      getUserdata(userid) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/esam/persona/id/${userid}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.persona;
            data.text = `${data.nombres} ${data.primer_apellido} ${data.segundo_apellido}`;
            vue.estudiantes.push(data);
            vue.filtroestudiante = data;
            // window.console.log(data);
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      saveData() {
        this.msg = '';
        if (!this.carga_horaria || this.carga_horaria < 0) this.msg = 'Ingrese la carga horaria.';
        if (!this.base64cert) this.msg = 'Ingrese el fondo del certificado.';
        if (typeof this.filtroestudiante != 'object' || !this.filtroestudiante) this.msg = 'Seleccione al docente.';
        if (this.msg) return;

        let index = (this.base64cert + '').indexOf('base64,') + 7;
        let base = (this.base64cert + '').substring(index);

        let input = {
          id: this.parametros.programa_modulo_id,
          docente_id: this.filtroestudiante.id,
          carga_horaria: this.carga_horaria,
          certificado_base64: base,
        };
        if (this.archivo_id) input.archivo_id = this.archivo_id;

        window.console.log(input);
        /*let a = 5;
        if (a > 1) return;*/
        this.loading = true;
        let vue = this;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/programamodulocertificado`,
          headers: {},
          data: input,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(response, data);
            if (typeof response.data == 'string') {
              let res = JSON.parse(response.data);
              window.console.log(res);
            } else if (data.id) {
              vue.msg = 'Guardado.';
            }
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error.response);
            if(error.response && error.response.data) vue.msg = error.response.data.data;
            else vue.msg = 'error desconocido.';
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.archivo_id = null;
      this.parametros.modulo_id = this.$route.query.modulo_id;
      this.parametros.nombre = this.$route.query.nombre;
      this.parametros.numero = this.$route.query.numero;
      this.parametros.programa_modulo_id = parseInt(this.$route.query.programa_modulo_id);
      this.getSaveData(this.parametros.programa_modulo_id);
      // this.getFileById();
    },
  };
</script>
